function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.1475 10.3851C32.0167 9.25424 30.1766 9.25431 29.0454 10.3854C28.6974 10.7336 26.4761 12.9568 26.1367 13.2965V5.63488C26.1367 4.86015 25.835 4.13183 25.2872 3.58404L22.5527 0.849492C22.005 0.301641 21.2766 0 20.5018 0H3.90039C2.30112 0 1 1.30112 1 2.90039V30.0996C1 31.6989 2.30112 33 3.90039 33H23.2363C24.8356 33 26.1367 31.6989 26.1367 30.0996V21.5036L33.1474 14.4869C34.281 13.3535 34.2812 11.5187 33.1475 10.3851ZM20.336 1.93359C20.5187 1.93359 20.8706 1.90195 21.1855 2.21674L23.92 4.95129C24.2268 5.25815 24.2032 5.5944 24.2032 5.80078H20.336V1.93359ZM24.2031 30.0996C24.2031 30.6327 23.7695 31.0664 23.2363 31.0664H3.90039C3.3673 31.0664 2.93359 30.6327 2.93359 30.0996V2.90039C2.93359 2.3673 3.3673 1.93359 3.90039 1.93359H18.4023V6.76758C18.4023 7.30151 18.8352 7.73438 19.3691 7.73438H24.2031V15.2318C24.2031 15.2318 21.3508 18.0865 21.3507 18.0866L19.9841 19.4532C19.878 19.5593 19.798 19.6888 19.7505 19.8311L18.3832 23.9329C18.2674 24.2803 18.3578 24.6634 18.6168 24.9223C18.8761 25.1816 19.2593 25.2716 19.6061 25.1559L23.7079 23.7886C23.8503 23.7412 23.9797 23.6612 24.0858 23.555L24.2031 23.4377V30.0996ZM22.0349 20.1369L23.4022 21.5041L22.8799 22.0264L20.8291 22.71L21.5127 20.6591L22.0349 20.1369ZM24.7692 20.1366L23.4019 18.7693C24.13 18.0407 27.3635 14.8044 28.0493 14.118L29.4166 15.4852L24.7692 20.1366ZM31.7799 13.1199L30.7833 14.1174L29.416 12.7502L30.413 11.7524C30.7902 11.3754 31.4034 11.3755 31.7803 11.7524C32.1572 12.1294 32.1592 12.7406 31.7799 13.1199Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.3684 9.66797H5.83325C5.29932 9.66797 4.86646 10.1008 4.86646 10.6348C4.86646 11.1687 5.29932 11.6016 5.83325 11.6016H19.3684C19.9023 11.6016 20.3352 11.1687 20.3352 10.6348C20.3352 10.1008 19.9023 9.66797 19.3684 9.66797Z",
  fill: "url(#paint1_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5012 13.5352H5.83325C5.29932 13.5352 4.86646 13.968 4.86646 14.502C4.86646 15.0359 5.29932 15.4688 5.83325 15.4688H15.5012C16.0352 15.4688 16.468 15.0359 16.468 14.502C16.468 13.968 16.0352 13.5352 15.5012 13.5352Z",
  fill: "url(#paint2_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5012 17.4023H5.83325C5.29932 17.4023 4.86646 17.8352 4.86646 18.3691C4.86646 18.9031 5.29932 19.3359 5.83325 19.3359H15.5012C16.0352 19.3359 16.468 18.9031 16.468 18.3691C16.468 17.8352 16.0352 17.4023 15.5012 17.4023Z",
  fill: "url(#paint3_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5012 21.2695H5.83325C5.29932 21.2695 4.86646 21.7024 4.86646 22.2363C4.86646 22.7703 5.29932 23.2031 5.83325 23.2031H15.5012C16.0352 23.2031 16.468 22.7703 16.468 22.2363C16.468 21.7024 16.0352 21.2695 15.5012 21.2695Z",
  fill: "url(#paint4_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.3684 27.1993H13.5676C13.0337 27.1993 12.6008 27.6322 12.6008 28.1661C12.6008 28.7001 13.0337 29.1329 13.5676 29.1329H19.3684C19.9023 29.1329 20.3352 28.7001 20.3352 28.1661C20.3352 27.6322 19.9023 27.1993 19.3684 27.1993Z",
  fill: "url(#paint5_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 8.00987,
  y1: 1.38154e-06,
  x2: 30.5373,
  y2: 3.40505,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 8.15256,
  y1: 9.66797,
  x2: 12.5392,
  y2: 14.9728,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 7.33104,
  y1: 13.5352,
  x2: 11.7759,
  y2: 17.5666,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 7.33104,
  y1: 17.4023,
  x2: 11.7759,
  y2: 21.4338,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 7.33104,
  y1: 21.2695,
  x2: 11.7759,
  y2: 25.3009,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 14.2439,
  y1: 27.1993,
  x2: 18.1988,
  y2: 29.5907,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/document.1d287d23.svg";
export { SvgComponent as ReactComponent };